import { Component, computed, Input, OnInit, Signal } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { Sort } from '@angular/material/sort';
import { KanbanViewComponent } from '../../../../shared/components/kanban-view/kanban-view.component';
import { HttpUtilitiesService } from '../../../../utilities/http-utilities.service';
import { EWorkflow } from '../../items.interface';
import { BaseItemView } from '../base-item-view.component';
import { ItemViewStore } from '../item-view.store';
import { IDatatableItem } from './items-kanban.interface';

@Component({
  imports: [MatCard, KanbanViewComponent],
  providers: [HttpUtilitiesService, ItemViewStore],
  selector: 'app-items-kanban',
  styleUrls: ['items-kanban.component.scss'],
  templateUrl: './items-kanban.component.html',
})
export class ItemsKanbanComponent extends BaseItemView implements OnInit {
  @Input() public boardKey: string | null = null;

  public readonly items: Signal<IDatatableItem[]> = computed(() => {
    return this.store.data$().map(this.formatData);
  });

  public readonly kanbanColumns: EWorkflow[] = [EWorkflow.todo, EWorkflow.inProgress, EWorkflow.done];

  constructor() {
    super('kanban');
  }

  public override ngOnInit(): void {
    const sort: Sort = [
      { active: 'currentWorkflowStepId', direction: 'asc' },
      { active: 'rank', direction: 'asc' },
    ] as unknown as Sort;

    this.datatableParams$.next({
      limit: 1000,
      page: 1,
      sort,
    });

    super.ngOnInit();
  }
}
